<div fxLayout="row" fxLayoutAlign="{{align}} center" fxLayoutGap="5px"
     *ngIf="form && statesOptions">

  <mat-form-field>
    <mat-progress-bar [mode]="'indeterminate'" *ngIf="onSaving"></mat-progress-bar>
    <mat-select [formControl]="control"
                placeholder="Etat du formulaire"
                [disabled]="onSaving"
                [(ngModel)]="stateCurrent"
                (selectionChange)="onSelect($event)"
                data-cy="select-form-state">
      <mat-select-trigger>
        <mat-icon>{{stateCurrent?.icon}}</mat-icon>&nbsp;{{stateCurrent?.label}}
      </mat-select-trigger>
      <mat-option *ngFor="let state of statesOptions" [value]="state" [attr.data-cy]="'option-form-states-'+state.id">
        <mat-icon [ngStyle]="{'color': state?.color || 'initial'}">{{state.icon}}</mat-icon>{{state.label}}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
